import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { PageSubmitButton } from 'Views/Page/Components/PageSubmitButton/PageSubmitButton';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import { WizardLayout, LayoutPaper, LayoutPaperActions } from '../Components';

export const Layout = () => {
  const { pageContentResource } = usePageContentContext();

  return (
    <WizardLayout>
      <FDContentContainer maxWidth={'sm'}>
        <LayoutPaper>
          <FDStack direction={'column'} spacing={2} paddingY={2}>
            <MetaControlField
              attr={'citizenship'}
              CustomProps={{ fullWidth: true }}
            />
            <MetaControlField
              attr={'existingDocuments'}
              CustomProps={{ fullWidth: true }}
            />
            <MetaControlField
              attr={'maritalStatus'}
              CustomProps={{ fullWidth: true }}
            />
            <MetaControlField
              attr={'assets'}
              CustomProps={{
                fullWidth: true,
                helperTextValue: pageContentResource.attr('assetsHelperText'),
              }}
            />
          </FDStack>
          <LayoutPaperActions>
            <PageSubmitButton resource={pageContentResource} />
          </LayoutPaperActions>
        </LayoutPaper>
      </FDContentContainer>
    </WizardLayout>
  );
};
